import { render, staticRenderFns } from "./msgTemplatesList.vue?vue&type=template&id=728c2ff6&scoped=true&"
import script from "./msgTemplatesList.vue?vue&type=script&lang=js&"
export * from "./msgTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./msgTemplatesList.vue?vue&type=style&index=0&id=728c2ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c2ff6",
  null
  
)

component.options.__file = "msgTemplatesList.vue"
export default component.exports